import React, { Component } from "react";

import {
    MDBBtn,
    MDBSpinner,
    MDBModal,
    MDBModalHeader,
    MDBModalBody,
    MDBModalFooter,
    MDBIcon,
    toast,
} from "mdbreact";

import SuppressedDevicesTable from "../../../components/NetworkMgmt/Venues/Datatables/SuppressedDevicesTable";

import { withTranslation } from "react-i18next";

import axios from "../../../axios";

class ViewSuppressedDevices extends Component {
    constructor(props) {
        super(props);
        this.state = {
            suppressedDevices: undefined,
            loadingSuppressedDevices: false,
            modalClearSuppression: false,
            clearingSuppression: false,
            disabled:
                sessionStorage.getItem("customerSupport") > 0 ? true : false,
        };
    }

    componentDidMount() {
        this.getSuppressedDevices();
    }

    getSuppressedDevices = () => {
        this.setState({ loadingSuppressedDevices: true });

        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            VenueID: this.props.venueID,
        };

        axios
            .post("/operatorconsole/venues/listSuppressedDevices", body, {
                headers: {},
            })
            .then((response) => {
                this.setState({
                    suppressedDevices:
                        response.data.SuppressedDevices ||
                        response.data.SuppressedMacs ||
                        response.data.suppressedDevices ||
                        response.data.Devices ||
                        [],
                    loadingSuppressedDevices: false,
                });
            })
            .catch((error) => {
                toast.error(
                    error?.response?.data?.message ||
                        "There was an error loading suppressed devices!",
                    {
                        closeButton: false,
                    }
                );
                this.setState({
                    suppressedDevices: [],
                    loadingSuppressedDevices: false,
                });
            });
    };

    toggleClearSuppression = () => {
        this.setState({
            modalClearSuppression: !this.state.modalClearSuppression,
        });
    };

    clearSuppressionList = () => {
        this.setState({ clearingSuppression: true });

        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            VenueID: this.props.venueID,
            clearSuppressedMacs: true,
        };

        axios
            .post("/operatorconsole/venues/configure", body, {
                headers: {},
            })
            .then((response) => {
                toast.success(
                    response?.data?.message || "Suppression list cleared!",
                    {
                        closeButton: false,
                    }
                );
                this.setState({
                    clearingSuppression: false,
                    modalClearSuppression: false,
                });
                this.getSuppressedDevices();
            })
            .catch((error) => {
                toast.error(
                    error?.response?.data?.message || "There was an error!",
                    {
                        closeButton: false,
                    }
                );
                this.setState({ clearingSuppression: false });
            });
    };

    render() {
        const { suppressedDevices } = this.state;
        const isEmpty =
            !suppressedDevices ||
            (Array.isArray(suppressedDevices)
                ? suppressedDevices.length === 0
                : Object.keys(suppressedDevices).length === 0);

        return (
            <>
                <MDBModal
                    isOpen={this.state.modalClearSuppression}
                    toggle={this.toggleClearSuppression}
                    centered
                >
                    <MDBModalHeader toggle={this.toggleClearSuppression}>
                        Clear Suppression List
                    </MDBModalHeader>
                    <MDBModalBody>
                        This will remove all devices from the suppression list
                        and allow them to attempt to re-authenticate. If devices
                        continue to connect with an invalid PSK, they will be
                        added to the list again.
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn
                            color="danger"
                            onClick={this.clearSuppressionList}
                            disabled={this.state.clearingSuppression}
                        >
                            {this.state.clearingSuppression ? (
                                <div
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                >
                                    <span className="sr-only">Loading...</span>
                                </div>
                            ) : (
                                "Clear Suppression List"
                            )}
                        </MDBBtn>
                        <MDBBtn
                            color="primary"
                            onClick={this.toggleClearSuppression}
                            disabled={this.state.clearingSuppression}
                        >
                            Cancel
                        </MDBBtn>
                    </MDBModalFooter>
                </MDBModal>
                {this.state.loadingSuppressedDevices ? (
                    <MDBSpinner small />
                ) : (
                    <div className="servicePlans">
                        <SuppressedDevicesTable
                            suppressedDevices={suppressedDevices}
                        />
                    </div>
                )}
                <div className="text-right mt-3">
                    <MDBBtn
                        color="danger"
                        onClick={this.toggleClearSuppression}
                        disabled={
                            this.state.disabled ||
                            this.state.loadingSuppressedDevices ||
                            isEmpty
                        }
                    >
                        <MDBIcon icon="ban" className="mr-2" />
                        Clear Suppression List
                    </MDBBtn>
                </div>
            </>
        );
    }
}

export default withTranslation()(ViewSuppressedDevices);
